export { default } from './content-block';
